export default __webpack_public_path__ + "static/media/redemtionthank.29dff47b.png";